import { useState } from 'react';

export default function useInputRadio({ onChange, checked, value, disabled }) {
  const [animation, setAnimation] = useState(0);

  function handleClick(e) {
    if (disabled) return;
    onChange(e, !checked);
    setAnimation(1);
  }

  function handleKeyDown(e) {
    if (disabled) return;

    // Manejar Enter y Space para activar el radio
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!checked) {
        onChange(e, true);
        setAnimation(1);
      }
    }

    // Manejar flechas para navegación entre radios del mismo grupo
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const radioGroup = document.getElementsByName(e.target.name);
      const currentIndex = Array.from(radioGroup).indexOf(e.target);
      let nextIndex;

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        // Siguiente radio
        nextIndex = (currentIndex + 1) % radioGroup.length;
      } else {
        // Radio anterior
        nextIndex = currentIndex === 0 ? radioGroup.length - 1 : currentIndex - 1;
      }

      const nextRadio = radioGroup[nextIndex];
      if (nextRadio && !nextRadio.disabled) {
        nextRadio.focus();
        nextRadio.click();
      }
    }
  }

  function animationEnd() {
    setAnimation(0);
  }

  return { animation, handleClick, handleKeyDown, animationEnd };
}
